import axios from 'axios'
import baseUrl from './baseUrl'

// 创建通用业务接口的 axios 实例
const service = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  timeout: 120 * 1000
})

// 请求拦截器
// 请求拦截器：自动附加 Token 和 UID 请求头
service.interceptors.request.use(config => {
  const tokenMessage = JSON.parse(localStorage.getItem('zstek-mis-web-token'))
  if (tokenMessage) {
    config.headers.Token = tokenMessage.token
    config.headers.UID = tokenMessage.uid
  }
  config.headers['Content-type'] = 'application/json'
  return config
})

// 响应拦截器：统一处理响应结果
service.interceptors.response.use(response => {
  return response
}, error => {
  return error
})

export default service
